import { setTimeEndActivity as setTimeEndActivityDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    end_activity?: String,
}

export const setTimeEndActivity = ({
    end_activity,
    eventEmitter
}: Props) => {
    setTimeEndActivityDiagram(end_activity);
};

